document.addEventListener('DOMContentLoaded', function() {
    const morse_converter = {
        'a': '.- ', 'b': '-... ', 'c': '-.-. ', 'd': '-.. ', 'e': '. ',
        'f': '..-. ', 'g': '--. ', 'h': '.... ', 'i': '.. ', 'j': '.--- ',
        'k': '-.- ', 'l': '.-.. ', 'm': '-- ', 'n': '-. ', 'o': '--- ',
        'p': '.--. ', 'q': '--.- ', 'r': '.-. ', 's': '... ', 't': '- ',
        'u': '..- ', 'v': '...- ', 'w': '.-- ', 'x': '-..- ', 'y': '-.-- ',
        'z': '--.. ', '1': '.---- ', '2': '..--- ', '3': '...-- ', '4': '....- ',
        '5': '..... ', '6': '-.... ', '7': '--... ', '8': '---.. ', '9': '----. ',
        '0': '----- ', '.': '.-.-.- ', ',': '--..-- ', '?': '..--.. ',
        "'": '.----. ', '!': '-.-.-- ', '/': '-..-. ', '(': '-.--. ',
        ')': '-.--.- ', '&': '.-... ', ':': '---... ', ';': '-.-.-. ',
        '=': '-...- ', '+': '.-.-. ', '-': '-....- ', '_': '..--.- ',
        '"': '.-..-. ', '$': '...-..- ', '@': '.--.-. ', ' ': '/'
    };

    let engravingType = null;
    let engravingText = null;
    let engravingFont = null;
    let parentVariantId = null;

    const variantPopup = document.querySelector('.variant-popup-customization');
    const popupButton = document.querySelector('.product-popup-button-wrapper button');
    const closeBtn = document.querySelector('.variant-popup-header .close-btn');
    const goBackBtn = document.querySelector('.variant-popup-header .go-back-btn');
    const rotatingCopy = [
        "our initials (JFK)",
        "The date you met (03.03.2003)",
        "Children's names (Sarah)",
        "Your nickname for each other (Peanut)",
        "My ♡ is yours",
        "You complete me"
    ];
    const rotatingCopySelector = document.querySelector('.popular-engravings span');
    const morseCodeInput = document.querySelector('#morse-code-engraving-input');
    const morseCodeTranslation = document.querySelector('#morse-code-translation');
    let currentIndex = 0;
    let rotatingInterval = null;

    // ── Morse code live translation ──────────────────────────────────────────
    if (morseCodeInput && morseCodeTranslation) {
        morseCodeInput.addEventListener('keyup', function() {
            const value = morseCodeInput.value;
            let output = '';
            for (let i = 0; i < value.length; i++) {
                const char = value.charAt(i).toLowerCase();
                output += morse_converter[char] || '';
            }
            morseCodeTranslation.value = output;
        });
    }

    // ── Rotating copy ────────────────────────────────────────────────────────
    function handleRotatingCopy() {
        if (!rotatingCopySelector) return;
        if (rotatingInterval) clearInterval(rotatingInterval);
        currentIndex = 0;
        rotatingCopySelector.textContent = rotatingCopy[0];
        rotatingInterval = setInterval(function() {
            currentIndex = (currentIndex + 1) % rotatingCopy.length;
            rotatingCopySelector.textContent = rotatingCopy[currentIndex];
        }, 2000);
    }

    // ── Apply UI changes based on engraving type ─────────────────────────────
    function applyEngravingTypeUI(type) {
        const fontWrapper = document.querySelector('.engraving-font-item-wrapper');
        const imageWrapper = document.querySelector('.add-engraving-wrapper .image-wrapper');
        const engravingTitle = document.querySelector('[data-type="add-engraving"] h2');

        if (fontWrapper) {
            fontWrapper.style.display = (type === 'Morse Code') ? 'none' : 'block';
        }
        if (imageWrapper) {
            imageWrapper.style.display = (type === 'Coordinates') ? 'none' : 'block';
        }
        if (engravingTitle) {
            if (type === 'Coordinates') {
                engravingTitle.textContent = "Which coordinates and font would you like to place on the pieces?";
            } else if (type === 'Morse Code') {
                engravingTitle.textContent = "What text would you like to place on the pieces?";
            } else {
                engravingTitle.textContent = "What text and font would you like to place on the pieces?";
            }
        }
    }

    // ── Helpers ──────────────────────────────────────────────────────────────
    function removeActiveClass(selector) {
        document.querySelectorAll(selector).forEach(block => block.classList.remove('active'));
    }

    function handleStepCount(currentStep, totalStep) {
        const currentStepEl = document.querySelector('.variant-popup-header .current-step');
        const totalStepsEl = document.querySelector('.variant-popup-header .total-steps');
        if (currentStepEl) currentStepEl.innerHTML = currentStep;
        if (totalStep && totalStepsEl) totalStepsEl.innerHTML = totalStep;
    }

    function resetPopup() {
        if (variantPopup) variantPopup.classList.remove('active');
        document.body.style.overflow = 'unset';
        removeActiveClass('.variant-popup-body-item');
        const firstItem = document.querySelectorAll('.variant-popup-body-item')[0];
        if (firstItem) firstItem.classList.add('active');
        handleStepCount(1);
        if (rotatingInterval) clearInterval(rotatingInterval);
    }

    // ── Auto-select first option in every group if nothing active ─────────────
    function autoSelectDefaults() {
        document.querySelectorAll(
            '.select-product-finish-wrapper, .select-product-engraving-wrapper'
        ).forEach(wrapper => {
            if (!wrapper.querySelector('.product-option-block.active')) {
                const firstBlock = wrapper.querySelector('.product-option-block');
                if (firstBlock) firstBlock.classList.add('active');
            }
        });
    }

    // ── FIX: Build variant title correctly ────────────────────────────────────
    // Excludes .select-stone-block from finish/engraving wrapper loop
    // to prevent double-counting, then appends stone value once at the end.
    function buildVariantTitle() {
        const parts = [];

        document.querySelectorAll(
            '.select-product-finish-wrapper, .select-product-engraving-wrapper'
        ).forEach(wrapper => {
            const active = wrapper.querySelector(
                '.product-option-block.active:not(.select-stone-block)'
            );
            if (active && active.dataset.value) {
                parts.push(active.dataset.value);
            }
        });

        // Append stone value exactly once
        const activeStone = document.querySelector('.select-stone-block.product-option-block.active');
        if (activeStone && activeStone.dataset.value) {
            parts.push(activeStone.dataset.value);
        }

        return parts.join(' / ');
    }

    // ── Fetch variant details from hidden list ───────────────────────────────
    function fetchVariantDetails(variantTitle) {
        const variantSelector = document.querySelector(
            `.hidden-variant-item[data-variant-title="${variantTitle}"]`
        );
        const addBtn = document.querySelector('.select-stone-add-btn button');
        if (!addBtn) return false;

        console.log('[Popup] Looking up variant:', JSON.stringify(variantTitle));

        if (!variantSelector) {
            console.warn('[Popup] No variant found for title:', variantTitle);
            console.warn('[Popup] Available titles:');
            document.querySelectorAll('.hidden-variant-item').forEach(el => {
                console.log('  >', JSON.stringify(el.dataset.variantTitle));
            });
            addBtn.textContent = 'Unavailable';
            addBtn.setAttribute('disabled', true);
            parentVariantId = null;
            return false;
        }

        const variantId        = variantSelector.dataset.variantId;
        const variantAvailable = variantSelector.dataset.variantAvailable;
        const variantPrice     = variantSelector.dataset.variantPrice;
        console.log('[Popup] Matched:', variantId, variantAvailable, variantPrice);

        parentVariantId = variantId;

        if (variantAvailable === 'true') {
            addBtn.innerHTML = 'Add to cart -&nbsp;' + variantPrice;
            addBtn.removeAttribute('disabled');
        } else {
            addBtn.textContent = 'Sold Out';
            addBtn.setAttribute('disabled', true);
        }

        return true;
    }

    function handleVariantChange() {
        fetchVariantDetails(buildVariantTitle());
    }

    // ── Add to cart ───────────────────────────────────────────────────────────
    function handleAddToCart() {
        if (!parentVariantId) {
            console.error('[Popup] No variant selected — parentVariantId is null');
            alert('Please select a size/option before adding to cart.');
            return;
        }

        const data = {
            quantity: 1,
            id: parseInt(parentVariantId, 10),
            properties: {
                "Select engraving type:": engravingType
            }
        };

        if (engravingType === 'Morse Code') {
            const morseEl = document.querySelector('#morse-code-engraving-input');
            const morseVal = morseEl ? morseEl.value.trim() : '';
            if (morseVal.length > 0) data.properties["Morse Code"] = morseVal;
        }

        if (engravingType === 'Coordinates') {
            data.properties["Select Engraving Font"] = engravingFont;
            const latEl = document.querySelector('#coordinates-latitude');
            const lngEl = document.querySelector('#coordinates-longitude');
            const latVal = latEl ? latEl.value.trim() : '';
            const lngVal = lngEl ? lngEl.value.trim() : '';
            if (latVal.length > 0) data.properties["Latitude"] = latVal;
            if (lngVal.length > 0) data.properties["Longitude"] = lngVal;
        }

        if (engravingType === 'Text') {
            data.properties["Select Engraving Font"] = engravingFont;
            const textEl = document.querySelector('#text-engraving-input');
            const textVal = textEl ? textEl.value.trim() : '';
            if (textVal.length > 0) data.properties["Engrave text"] = textVal;
        }

        const formData = { items: [data] };
        console.log('[Popup] Adding to cart:', formData);

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        })
        .then(response => response.json())
        .then(responseData => {
            console.log('[Popup] Cart response:', responseData);
            document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: { quantity: 1 },
            }));
            resetPopup();
        })
        .catch(error => {
            console.error('[Popup] Cart error:', error);
        });
    }

    // ── Open popup ────────────────────────────────────────────────────────────
    if (popupButton) {
        popupButton.addEventListener('click', function() {
            const activeSwitcher =
                document.querySelector('.custom_2x_cuff_bracelet .custom-switcher-btn.active-switcher') ||
                document.querySelector('.custom-switcher-btn.active-switcher') ||
                document.querySelector('.custom-switcher-btn');

            engravingType = (activeSwitcher && activeSwitcher.dataset.type) ? activeSwitcher.dataset.type : 'Text';

            applyEngravingTypeUI(engravingType);
            removeActiveClass('.add-engraving-input-container');

            const engravingInputContainer = document.querySelector(`[data-engraving-type="${engravingType}"]`);
            if (engravingInputContainer) engravingInputContainer.classList.add('active');

            if (variantPopup) variantPopup.classList.add('active');
            document.body.style.overflow = 'hidden';

            handleRotatingCopy();
            autoSelectDefaults();
            handleVariantChange();
        });
    }

    // ── Close ─────────────────────────────────────────────────────────────────
    if (closeBtn) {
        closeBtn.addEventListener('click', resetPopup);
    }

    // ── Go back ───────────────────────────────────────────────────────────────
    if (goBackBtn) {
        goBackBtn.addEventListener('click', function() {
            const activeItem = document.querySelector('.variant-popup-body-item.active');
            if (!activeItem) return;
            const currentStep = parseInt(activeItem.dataset.currentStep);

            if (currentStep === 1) {
                resetPopup();
            } else {
                activeItem.classList.remove('active');
                const prevStep = (engravingType === 'Morse Code' && currentStep === 4)
                    ? currentStep - 2
                    : currentStep - 1;
                const prevItem = document.querySelector(`[data-current-step="${prevStep}"]`);
                if (prevItem) prevItem.classList.add('active');
                handleStepCount(prevStep);
            }
        });
    }

    // ── Step: engraving type chooser ──────────────────────────────────────────
    function handleEngravingType(selector) {
        selector.querySelectorAll('.engraving-type-item-block').forEach(block => {
            block.addEventListener('click', function() {
                const currentStep = parseInt(selector.dataset.currentStep);
                engravingType = block.dataset.type;

                removeActiveClass('.engraving-type-item-block');
                block.classList.add('active');
                selector.classList.remove('active');

                const nextItem = document.querySelector(`[data-current-step="${currentStep + 1}"]`);
                if (nextItem) nextItem.classList.add('active');

                removeActiveClass('.add-engraving-input-container');
                const engravingInputContainer = document.querySelector(`[data-engraving-type="${engravingType}"]`);
                if (engravingInputContainer) engravingInputContainer.classList.add('active');

                applyEngravingTypeUI(engravingType);
                handleStepCount(currentStep + 1, 2);
            });
        });
    }

    // ── Step: engraving text ──────────────────────────────────────────────────
    function handleAddEngraving(selector) {
        const addEngravingButton = selector.querySelector('.add-engraving-next-btn button');
        if (!addEngravingButton) return;
        addEngravingButton.addEventListener('click', function() {
            const currentStep = parseInt(selector.dataset.currentStep);
            const input = selector.querySelector('input');
            engravingText = input ? input.value : '';
            selector.classList.remove('active');
            const nextItem = document.querySelector(`[data-current-step="${currentStep + 1}"]`);
            if (nextItem) nextItem.classList.add('active');
            handleStepCount(currentStep + 1);
        });
    }

    // ── Step: font selection ──────────────────────────────────────────────────
    function handleSelectEngravingFont(selector) {
        selector.querySelectorAll('.engraving-font-item-block').forEach(block => {
            block.addEventListener('click', function() {
                engravingFont = block.dataset.font;
                removeActiveClass('.engraving-font-item-block');
                block.classList.add('active');
            });
        });
    }

    // ── Step: variant / stone selector ───────────────────────────────────────
    function handleSelectStone(selector) {
        // Auto-select first in each group on init
        selector.querySelectorAll(
            '.select-product-finish-wrapper, .select-product-engraving-wrapper'
        ).forEach(wrapper => {
            if (!wrapper.querySelector('.product-option-block.active')) {
                const firstBlock = wrapper.querySelector('.product-option-block');
                if (firstBlock) firstBlock.classList.add('active');
            }
        });

        // Stone toggle clicks
        selector.querySelectorAll('.select-stone-block').forEach(block => {
            block.addEventListener('click', function() {
                removeActiveClass('.select-stone-block');
                block.classList.add('active');
                handleVariantChange();
            });
        });

        // Finish option clicks
        selector.querySelectorAll('.select-finish-block').forEach(block => {
            block.addEventListener('click', function() {
                block.closest('.select-product-finish-wrapper')
                    .querySelectorAll('.select-finish-block')
                    .forEach(b => b.classList.remove('active'));
                block.classList.add('active');
                handleVariantChange();
            });
        });

        // Engraving count / size option clicks
        selector.querySelectorAll('.select-engraving-block').forEach(block => {
            block.addEventListener('click', function() {
                block.closest('.select-product-engraving-wrapper')
                    .querySelectorAll('.select-engraving-block')
                    .forEach(b => b.classList.remove('active'));
                block.classList.add('active');
                handleVariantChange();
            });
        });

        // Add to cart button
        const addBtn = selector.querySelector('.select-stone-add-btn button');
        if (addBtn) {
            addBtn.addEventListener('click', handleAddToCart);
        }

        // Trigger initial variant resolution
        handleVariantChange();
    }

    // ── Wire up all steps ─────────────────────────────────────────────────────
    document.querySelectorAll('.variant-popup-body-item').forEach(item => {
        const type = item.dataset.type;
        if (type === 'select-engraving-type') handleEngravingType(item);
        if (type === 'add-engraving') {
            handleAddEngraving(item);
            handleSelectEngravingFont(item);
        }
        if (type === 'select-stone') handleSelectStone(item);
    });

    // ── Sync finish selection from main PDP to popup on variant change ────────
    // When user selects a finish on the main PDP (outside popup), keep popup in sync
    setTimeout(function() {
        const selected_color = document.querySelector('[data-option-name="FINISH"] input:checked')?.value || '';
        if (selected_color) {
            console.log('[Popup] Syncing PDP color to popup:', selected_color);
            document.querySelectorAll('.select-finish-block.product-option-block').forEach(block => {
                block.classList.remove('active');
            });
            const matchingBlock = document.querySelector(
                `.select-finish-block.product-option-block[data-value="${selected_color}"]`
            );
            if (matchingBlock) matchingBlock.classList.add('active');
        }
    }, 500);
});